export default __webpack_public_path__ + "static/media/The Effect of Mercury Retrograde on All Signs.974725ab.png";